import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=816299c6&"
import script from "./personal.vue?vue&type=script&lang=js&"
export * from "./personal.vue?vue&type=script&lang=js&"
import style0 from "./personal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports